(() => {
  const selector = '[data-cd-card-gallery]';

  function init(root = document) {
    const galleries = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    for (const gallery of galleries) {
      if (gallery.dataset.cdGalleryReady === 'true') continue;
      gallery.dataset.cdGalleryReady = 'true';
      const track = gallery.querySelector('.cd-card-gallery__track');
      const dots = [...gallery.querySelectorAll('.cd-card-gallery__dot')];
      if (!track || track.children.length < 2) continue;

      let startX = 0;
      let startY = 0;
      let swiped = false;
      let scrollFrame = 0;

      function updateDots() {
        scrollFrame = 0;
        const index = Math.min(dots.length - 1, Math.max(0, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }

      track.addEventListener('scroll', () => {
        if (!scrollFrame) scrollFrame = requestAnimationFrame(updateDots);
      }, { passive: true });

      track.addEventListener('wheel', event => {
        if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) event.stopPropagation();
      }, { passive: true });

      gallery.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'touch') return;
        startX = event.clientX;
        startY = event.clientY;
        swiped = false;
        event.stopPropagation();
      }, { passive: true });

      gallery.addEventListener('pointermove', event => {
        if (event.pointerType !== 'touch') return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          event.stopPropagation();
        }
      }, { passive: true });

      gallery.addEventListener('pointerup', event => {
        if (event.pointerType === 'touch' && swiped) event.stopPropagation();
      }, { passive: true });

      gallery.addEventListener('touchstart', event => {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        swiped = false;
        event.stopPropagation();
      }, { passive: true });

      gallery.addEventListener('touchmove', event => {
        const dx = event.touches[0].clientX - startX;
        const dy = event.touches[0].clientY - startY;
        if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          event.stopPropagation();
        }
      }, { passive: true });

      gallery.addEventListener('touchend', event => {
        if (!swiped) return;
        event.stopPropagation();
        setTimeout(() => { swiped = false; }, 350);
      }, { passive: true });

      gallery.addEventListener('click', event => {
        if (!swiped) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);
    }
  }

  function start() {
    init();
    document.addEventListener('shopify:section:load', event => init(event.target));
    let pending = false;
    const observer = new MutationObserver(() => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        init();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
